/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Custom_DescriptionInputs */

const en_admin_settings_custom_description = /** @type {(inputs: Admin_Settings_Custom_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add your own key/value configs. Keys must be unique and not collide with built-in settings.`)
};

/**
* | output |
* | --- |
* | "Add your own key/value configs. Keys must be unique and not collide with built-in settings." |
*
* @param {Admin_Settings_Custom_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_custom_description = /** @type {((inputs?: Admin_Settings_Custom_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Custom_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_custom_description(inputs)
});
export { admin_settings_custom_description as "admin.settings.custom.description" }